import { render, staticRenderFns } from "./search-stock-input.vue?vue&type=template&id=006a22e4&"
import script from "./search-stock-input.vue?vue&type=script&lang=js&"
export * from "./search-stock-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports